import { ChangeEvent, useState } from "react";
import { IoBriefcaseOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import InputBox from "../../General/InputBox";
import { GeneralBtn } from "../../General";
import styled from "styled-components";
import { AppDispatch, RootState } from "../../../store";
import {
  clearSearchField,
  collectInputField,
  hideJobTypeDropdown,
  searchForEngeeringPostJobs,
  searchForPostJobs,
  toggleJobTypeDropdown,
} from "../../../features/postJob/getAllPostJobsSlice";

const FilterJobs = () => {
  const { searchJob, isShowJobType } = useSelector(
    (store: RootState) => store.allPostJobsStore
  );

  const [filterByJobType, setFilterByJobType] = useState("Filter by job type");

  const dispatch = useDispatch<AppDispatch>();
  const { pathname } = useLocation();

  // Change of search field
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    dispatch(collectInputField(e.target.value));
    const search = e.target.value;

    // Activate engineering jobs search
    if (pathname.includes("engineering-jobs")) {
      dispatch(searchForEngeeringPostJobs({ search }));
      return;
    }
    // Activate all jobs search
    dispatch(searchForPostJobs({ search }));
  };

  // Show job type dropdown
  const handleJobType = () => {
    dispatch(toggleJobTypeDropdown());
  };

  // Job type dropdown values
  const handleJobTypeDropdown = (jobType: string) => {
    // console.log(jobType);
    setFilterByJobType(jobType);

    // Activate engineering filter job type
    if (pathname.includes("engineering-jobs")) {
      dispatch(searchForEngeeringPostJobs({ search: searchJob, jobType }));
      return;
    }
    // Activate all filter job type
    dispatch(searchForPostJobs({ search: searchJob, jobType }));
  };

  const handleClearFilter = () => {
    setFilterByJobType("Filter by job type");
    dispatch(clearSearchField());
  };

  return (
    <FilterJobWrapper>
      <InputBox
        jobName={""}
        typeName={"text"}
        inputName={"searchJob"}
        inputValue={searchJob}
        inputClassName="post__job__search__style"
        inputConClassName="post__job__search__con__style"
        placeholder="Search job by position or location"
        handleChange={handleChange}
      />

      <div className="btns__con">
        <GeneralBtn
          btnContent={filterByJobType}
          handleClick={handleJobType}
          icon={<IoBriefcaseOutline />}
          btnStyle="head__btn__style"
        />
        <GeneralBtn
          btnContent={"Clear Filter"}
          handleClick={handleClearFilter}
          btnStyle="head__btn__style"
        />

        {isShowJobType && (
          <div
            className="dropdown"
            onClick={() => dispatch(hideJobTypeDropdown())}
          >
            <GeneralBtn
              btnContent="Remote"
              handleClick={() => handleJobTypeDropdown("remote")}
              btnStyle="dropdown__btn"
            />
            <GeneralBtn
              btnContent="Onsite"
              handleClick={() => handleJobTypeDropdown("onsite")}
              btnStyle="dropdown__btn"
            />
            <GeneralBtn
              btnContent="Contract"
              handleClick={() => handleJobTypeDropdown("contract")}
              btnStyle="dropdown__btn"
            />
          </div>
        )}
      </div>
    </FilterJobWrapper>
  );
};

export default FilterJobs;

const FilterJobWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-block: 1rem;

  .post__job__search__con__style {
    width: 250px;
  }

  .post__job__search__style {
    width: 100%;
    height: 40px;
    padding-inline: 10px;
    font-size: 15px;
    border-radius: 5px;
    border: 1px solid #ccc;
  }

  .btns__con {
    position: relative;
    display: flex;
    align-self: flex-end;
    gap: 10px;
  }

  @media screen and (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;

    .post__job__search__con__style {
      align-self: flex-start !important;
    }

    .btns__con {
      align-self: flex-start;
      gap: 8px;
    }

    .head__btn__style {
      font-size: 14px;
    }
  }
  @media screen and (max-width: 420px) {
    .post__job__search__con__style {
      width: 100%;
    }

    .post__job__search__style {
      /* border: 2px solid red; */
    }
  }

  .dropdown {
    position: absolute;
    background-color: white;
    top: 35px;
    width: 150px;
    border-radius: 6px;
    padding: 4px 1rem 8px;
    box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
  }

  .dropdown__btn {
    border: none;
    margin-top: 4px;
  }
  .dropdown__btn:hover {
    background-color: inherit;
    color: #585757;
  }
`;
